/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".scrollable-entries[_ngcontent-%COMP%]{max-height:77vh;overflow-y:auto;overflow-x:hidden}.scrollable-entries[_ngcontent-%COMP%]::-webkit-scrollbar{width:12px;background-color:#f5f5f5}.scrollable-entries[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);border-radius:10px;background-color:#343a40}.scrollable-entries[_ngcontent-%COMP%]::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);border-radius:10px;background-color:#f5f5f5}"];
export { styles as styles };
